import React, {useState} from 'react';
import { useDataProvider, ReferenceArrayInput, useInput } from 'react-admin';
import FilesInput from './FilesInput.component';
import { useFormState } from 'react-final-form';

const Inputs = ({ items, groupsResourceTitleKey, filesGroupIdKey, choices, ...rest }) => {
	
	return choices.map(choice => {
		const groupItems = items.filter(item => item[filesGroupIdKey] == choice.id);
		
		return <FilesInput
			groupId={choice.id}
			key={choice.id}
			items={groupItems}
			title={choice[groupsResourceTitleKey]}
			transformFiles={(f) => ({file: f, [filesGroupIdKey]: choice.id})}
			{...rest}
		/>;
	});
};

const FileManagerGroupsInputProvider = ({groupsResourceName, groupsResourceSort, ...rest}) => {
	return (
		<ReferenceArrayInput reference={groupsResourceName} source="__empty__" sort={groupsResourceSort}>
			<Inputs {...rest} />
		</ReferenceArrayInput>
	);
};

export default FileManagerGroupsInputProvider;